import { PersistencePort } from '@/data/ports/PersistencePort';
import { DataSnapshot } from '@/types/domain';

const BASE = '/api/snapshot';

export const HttpApiAdapter: PersistencePort = {
  name: 'api',
  async health() {
    try {
      const r = await fetch(`${BASE}/health`, { credentials: 'include' });
      return { ok: r.ok, details: r.ok ? undefined : await r.text() };
    } catch (e: any) {
      return { ok: false, details: String(e) };
    }
  },
  async get() {
    const r = await fetch(`${BASE}`, { credentials: 'include' });
    if (r.status === 404) return null;
    if (!r.ok) throw new Error(await r.text());
    return (await r.json()) as DataSnapshot;
  },
  async put(data) {
    const r = await fetch(`${BASE}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      credentials: 'include',
    });
    if (!r.ok) throw new Error(await r.text());
  },
  async clear() {
    await fetch(`${BASE}`, { method: 'DELETE', credentials: 'include' });
  },
};
